import { cva } from 'class-variance-authority'

export const BackgroundVariants = {
  variant: {
    primary: 'bg-primary',
    secondary: 'bg-secondary',
    red: 'bg-red',
    green: 'bg-green',
    blue: 'bg-blue',
    purple: 'bg-purple',
    orange: 'bg-orange',
    glacial: 'bg-glacial',
    brown: 'bg-brown',
    pink: 'bg-pink',
    yellow: 'bg-yellow',
    inverse: 'bg-white',
    dark: 'bg-black',
    white: 'bg-white',
    inherit: 'bg-inherit',
    light: 'bg-light',
    black: 'bg-black',
    neutral: 'bg-neutral',
    ivory: 'bg-ivory',
    burgundy: 'bg-burgundy',
    sahara: 'bg-sahara',
  },
}

export const BackgroundMediumVariants = {
  variant: {
    primary: 'bg-primary-medium',
    secondary: 'bg-secondary-medium',
    red: 'bg-red-medium',
    green: 'bg-green-medium',
    blue: 'bg-blue-medium',
    purple: 'bg-purple-medium',
    orange: 'bg-orange-medium',
    glacial: 'bg-glacial-medium',
    brown: 'bg-brown-medium',
    pink: 'bg-pink-medium',
    yellow: 'bg-yellow-medium',
    inverse: 'bg-white-medium',
    dark: 'bg-black-medium',
    white: 'bg-white-medium',
    inherit: 'bg-inherit-medium',
    light: 'bg-gray-300-medium',
    black: 'bg-black-medium',
    neutral: 'bg-neutral-medium',
    ivory: 'bg-ivory-medium',
    burgundy: 'bg-burgundy-medium',
    sahara: 'bg-sahara-medium',
  },
}

export const BackgroundLightVariants = {
  variant: {
    primary: 'bg-primary-light',
    secondary: 'bg-secondary-light',
    red: 'bg-red-light',
    green: 'bg-green-light',
    blue: 'bg-blue-light',
    purple: 'bg-purple-light',
    orange: 'bg-orange-light',
    glacial: 'bg-glacial-light',
    brown: 'bg-brown',
    pink: 'bg-pink',
    yellow: 'bg-yellow',
    inverse: 'bg-white',
    dark: 'bg-black',
    white: 'bg-white',
    inherit: 'bg-inherit',
    light: 'bg-gray-100',
    black: 'bg-black',
    neutral: 'bg-neutral-light',
    ivory: 'bg-ivory',
    burgundy: 'bg-burgundy-light',
    sahara: 'bg-sahara-light',
  },
}

export const BackgroundVariantsHover = {
  variant: {
    primary: 'hover:bg-primary',
    secondary: 'hover:bg-secondary',
    red: 'hover:bg-red',
    green: 'hover:bg-green',
    blue: 'hover:bg-blue',
    purple: 'hover:bg-purple',
    orange: 'hover:bg-orange',
    glacial: 'hover:bg-glacial',
    brown: 'hover:bg-brown',
    pink: 'hover:bg-pink',
    yellow: 'hover:bg-yellow',
    inverse: 'hover:bg-white',
    dark: 'hover:bg-black',
    white: 'hover:bg-white',
    inherit: 'hover:bg-inherit',
    light: 'hover:bg-gray-300',
    black: 'hover:bg-black',
    neutral: 'hover:bg-neutral-500',
    ivory: 'hover:bg-ivory',
    burgundy: 'hover:bg-burgundy',
    sahara: 'hover:bg-sahara',
  },
} as const

export const BackgroundMediumImportantVariants = {
  variant: {
    primary: '!bg-primary-medium',
    secondary: '!bg-secondary-medium',
    red: '!bg-red-medium',
    green: '!bg-green-medium',
    blue: '!bg-blue-medium',
    purple: '!bg-purple-medium',
    orange: '!bg-orange-medium',
    glacial: '!bg-glacial-medium',
    brown: '!bg-brown-medium',
    pink: '!bg-pink-medium',
    yellow: '!bg-yellow-medium',
    inverse: '!bg-white-medium',
    dark: '!bg-black-medium',
    white: '!bg-white-medium',
    inherit: '!bg-inherit-medium',
    light: '!bg-gray-300-medium',
    black: '!bg-black-medium',
    neutral: '!bg-neutral-medium',
    ivory: '!bg-ivory-medium',
    burgundy: '!bg-burgundy-medium',
    sahara: '!bg-sahara-medium',
  },
} as const

export const BackgroundMediumVariantsHover = {
  variant: {
    primary: 'hover:bg-primary-medium',
    secondary: 'hover:bg-secondary-medium',
    red: 'hover:bg-red-medium',
    green: 'hover:bg-green-medium',
    blue: 'hover:bg-blue-medium',
    purple: 'hover:bg-purple-medium',
    orange: 'hover:bg-orange-medium',
    glacial: 'hover:bg-glacial-medium',
    brown: 'hover:bg-brown-medium',
    pink: 'hover:bg-pink-medium',
    yellow: 'hover:bg-yellow-medium',
    inverse: 'hover:bg-white-medium',
    dark: 'hover:bg-black-medium',
    white: 'hover:bg-white-medium',
    inherit: 'hover:bg-inherit-medium',
    light: 'hover:bg-gray-300-medium',
    black: 'hover:bg-black-medium',
    neutral: 'hover:bg-neutral-500-medium',
    ivory: 'hover:bg-ivory-medium',
    burgundy: 'hover:bg-burgundy-medium',
    sahara: 'hover:bg-sahara-medium',
  },
} as const

export type BackgroundVariant = keyof typeof BackgroundVariants.variant

export const BackgroundDefaultVariants: { variant: BackgroundVariant } = {
  variant: 'primary',
}

export const getVariantClass = (
  variant: BackgroundVariant,
  light: boolean = false,
): string => {
  return light
    ? BackgroundLightVariants.variant[variant]
    : BackgroundVariants.variant[variant]
}

export const BackgroundStyle = cva('', {
  variants: BackgroundVariants,
  defaultVariants: BackgroundDefaultVariants,
})

export const BackgroundMediumStyle = cva('', {
  variants: BackgroundMediumVariants,
  defaultVariants: BackgroundDefaultVariants,
})

export const BackgroundLightStyle = cva('', {
  variants: BackgroundLightVariants,
  defaultVariants: BackgroundDefaultVariants,
})
